import { ErrorSummary } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../utils';
import { ErrorGroupWrapper } from '../formErrors/styledComponents';
import { hasErrors } from '../formErrors/utils';
import { ErrorLinkItem } from '../formErrors/errorLinkItem';

// Gass errors consists of three categories - the main category Gass, with two subgroups: "Gasskamin",
// and "Gasskjel med vannbåren varme".
export const GassErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.gass' });

  const errors = formState.errors.gass;

  const gassError = errors?.value?.kamin?.selected;
  const gasskaminErrors = errors?.value?.kamin?.value;
  const gasskjelErrors = errors?.value?.kjel?.value;

  if (!errors) {
    return null;
  }

  return (
    <Fragment>
      {gassError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={gassError} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}

      {hasErrors(gasskaminErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('kamin.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={gasskaminErrors?.installasjonsAr} />
            <ErrorLinkItem error={gasskaminErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={gasskaminErrors?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}

      {hasErrors(gasskjelErrors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('kjel.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={gasskjelErrors?.varmesentral?.installasjonsAr} />
            <ErrorLinkItem error={gasskjelErrors?.varmesentral?.vetInstallasjonsAr} />
            <ErrorLinkItem error={gasskjelErrors?.varmesentral?.varmesentralType} />
            <ErrorLinkItem error={gasskjelErrors?.varmesentral?.installertIOppvarmetRom} />
            <ErrorLinkItem error={gasskjelErrors?.installasjonsAr} />
            <ErrorLinkItem error={gasskjelErrors?.vetInstallasjonsAr} />
            <ErrorLinkItem error={gasskjelErrors?.serviceGjennomfortSiste2Ar} />
            <ErrorLinkItem error={gasskjelErrors?.bruk?.romoppvarming} />
            <ErrorLinkItem error={gasskjelErrors?.radiator?.selected} />
            <ErrorLinkItem error={gasskjelErrors?.radiator?.value?.termostatstyring} />
            <ErrorLinkItem error={gasskjelErrors?.gulvvarme?.value?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
    </Fragment>
  );
};
